import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Cookies from 'universal-cookie';
import { Navbar } from "../../modules/ui/Navbar";
import { SelectCustom } from '../../modules/ui/SelectCustom';

import { CustomTable } from "./tables/CustomTable";
import moment from "moment";
import { getAllEventosConRegistro } from "../../../database/dbEventosConRegistro";
import { getAllFromEduconCursosRegistrados } from "../../../database/dbEduconCursosRegistrados";
import { CustomDialog } from "../../modules/dialogs/CustomDialog";


export const Menu = () => {

    // Para personalizar la UI
    const cookies = new Cookies();
    const cookieId = cookies.get('id');

    // Para el conjunto de eventos disponibles
    const [events, setEvents] = useState([]);
    
    // Para el evento seleccionado en el listado
    const [event, setEvent] = useState({
        id: "",
        claveProyecto: "",
        tituloEvento: "",
        urlLogo: "",
        tabla: "",
        solicitudFolio: "",
        correoEvento: "",
        urlEvento: "",
        fechaInicio: "",
        disponible: ""
    })


    const handleInputChange = ({ target }) => {

        const item = events.find( e => e.id === target.value);
        // const item = events.filter( e => e.id === target.value);
        console.log({item});
        setEvent(item);
    };


    useEffect(() => {
        document.title = "[Menu] Consulta General";

        const isSessionActive = async() => {

            // Si no ha iniciado sesion, redirigir
            if (!cookieId ) {
                window.location.replace('./sign-in?p=admin');

            } else {

                const { data: educonCursosRegistrados } = await getAllFromEduconCursosRegistrados();
                // const { data } = await getAllFromEduconCursosActivos();
                // const educonCursosRegistrados = data;
                // const ofertados = data.filter( item => item.ofertado !== '0');
                console.log({educonCursosRegistrados});
                // Eventos de: Posgrado(educon), DEI (eventos), eventos sin cobro, etc.)
                const registrados = await getAllEventosConRegistro();
                const {data: eventosConRegistro} = await getAllEventosConRegistro();
                console.log({eventosConRegistro});

                //! 'eventosConRegistro.solicitudFolio' es el ID de la actividad (3 digitos) si es un EDUCON o el numero de solicitud (inicia con el año) si es un Congreso, etc.
                //! Sin embargo en el caso de EDUCON, ya no se van a agregar a esta tabla, por lo que a futuro solo sera el numero de solicitud de Eventos

                const eventsToShow = [];
                /**
                 {
                    "id": 21,
                    "claveProyecto": "20487",
                    "tituloEvento": "Introducción a R",
                    "urlLogo": "https://eventos.cibnor.mx/intranet/img/logo_cib.png",
                    "tabla": "Educon",
                    "solicitudFolio": "143",
                    "correoEvento": "RRINCON@cibnor.mx",
                    "urlEvento": null,
                    "fechaInicio": "2023-02-13T00:00:00Z",
                    "disponible": "true",
                    "registroActivo": "1"
                }
                 */

                //? Recorremos todos los EDUCON (aquellos dentro de sus dos años de vigencia en admon.) y los agregamos a 'eventsToShow'
                educonCursosRegistrados.forEach(educon => {
                    const event = {
                        id: educon.solicitudID,
                        // id: educon.folio,
                        claveProyecto: educon.cve_Proyec,
                        tituloEvento: educon.nombre,
                        urlLogo: "https://eventos.cibnor.mx/intranet/img/logo_cib.png",
                        tabla: "RegistroGeneral",
                        solicitudFolio: educon.solicitudID,
                        correoEvento: educon.correoEventos,
                        urlEvento: null,
                        fechaInicio: educon.fechaInicio,
                        disponible: "true",
                        registroActivo: "1"
                    }
                    eventsToShow.push(event);
                })


                //? Recorremos 'eventosConRegistro' para obtener todos los listados de congresos, talleres, etc.
                // TODO: agregar estos eventos

                // educonCursosRegistrados.forEach( ofertado => {
                //     const ofertadoProyecto = ofertado.cve_Proyec;
                //     const ofertadoFechaInicio = ofertado.fechaInicio.substring(0, 10);
                //     // console.log({ofertadoProyecto, ofertadoFechaInicio});
                    
                //     const educonValidado = registrados.data.find( registrado => {
                //         const registradoProyecto = registrado.claveProyecto;
                //         const registradoFechaInicio = registrado.fechaInicio.substring(0, 10);
                //         if (ofertadoProyecto === registradoProyecto && ofertadoFechaInicio === registradoFechaInicio) {
                //             return registrado;
                //         }
                //     });
                //     // console.log({educonValidado});
                //     if (educonValidado) {
                //         eventsToShow.push(educonValidado);
                //     }
                // })
                console.log({eventsToShow});
                
                //* Donde:
                //*  disponible["true", "false"]: se puede consultar para efectos de registros
                //*  registroActivo["1", "0"]: se pueden registrar los participantes 

                const eventsSorted = [...eventsToShow]
                .sort(
                    (a, b) => a.fechaInicio < b.fechaInicio ? 1 : -1,
                    // (a, b) => a.tituloEvento > b.tituloEvento ? 1 : -1,
                )
                console.log({eventsSorted});
                setEvents(eventsSorted);   
            }
        };
        isSessionActive();

    }, [cookieId])



    return (
        <>
        <Navbar nombre={ cookies.get('nombre') } />
        {/* Consulta general */}
        <Grid container spacing={2} sx={{ p: 2 }} >
        
            <Grid item xs={12} >
                <Typography variant="h5">Consulta General de Participantes a Eventos CIBNOR</Typography>
            </Grid>
            <Grid item xs={12} >
                <SelectCustom
                    parentCallback={ handleInputChange }
                    name={"table"}
                    label={"Registro a visualizar"}
                    variant={"standard"}
                    options={
                        events.map(( item, index ) => (
                            { 
                                value: item.id, 
                                label: `${ (item.fechaInicio !== '') 
                                    ? `[ ${ moment((item.fechaInicio).substring(0, 10)).format('DD-MM-YYYY') }` 
                                    : '[ update DB ]' } | ${ item.solicitudFolio } | ${ item.claveProyecto} ] ${item.tituloEvento}` 
                            }
                        ))
                    }
                />
            </Grid>

            <Grid item xs={12} display={ event.claveProyecto !== '' ? 'flex' : 'none' }>
                <CustomTable event={ event } />
            </Grid>

        </Grid>
        </>
    );
};
